<markant-dialog class="dialog" [open]="true" (close)="closeDialog.emit()">
  <div class="container">
    <div class="heading">
      <h2>
        {{
          (groupName
            ? 'dashboardOverview.groupAssignment.roleAssignment.headline'
            : 'user.details.role-assignment.headline'
          ) | transloco: { name: groupName }
        }}
      </h2>
      <p>
        <b>
          {{
            (groupName
              ? 'dashboardOverview.groupAssignment.roleAssignment.subTitle'
              : 'user.details.role-assignment.subTitle'
            ) | transloco
          }}
        </b>
        <br />
        <span>
          <b>
            {{
              'organization.users.invite.cartridgeView.infoNotice' | transloco
            }}
          </b>
        </span>
        <span>
          {{
            'organization.users.invite.cartridgeView.infoNoticeText' | transloco
          }}
        </span>
      </p>
    </div>

    <div class="user-role-assignment-container">
      <markant-platform-cartridge-role-assignment
        [organizationId]="organizationId"
        [groupName]="groupName"
        [groupId]="groupId"
        [userId]="userId"
      >
      </markant-platform-cartridge-role-assignment>
    </div>
  </div>

  <div slot="markant-dialog-footer">
    <markant-button
      colorScheme="primary"
      variant="clear"
      (click)="closeDialog.emit()"
    >
      {{ 'user.details.role-assignment.deleteDialogCancel' | transloco }}
    </markant-button>

    <markant-button
      colorScheme="primary"
      [loading]="loading"
      (click)="submitRoleAssignments()"
    >
      {{
        'user.details.role-assignment.assign-cartridge-roles-approve-button'
          | transloco
      }}
    </markant-button>
  </div>
</markant-dialog>
